import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress ResizeObserver warnings (harmless browser warnings)
const resizeObserverLoopErr = /ResizeObserver loop/i;
const originalError = console.error;
const originalWarn = console.warn;

// Suppress console.error
console.error = (...args) => {
  const firstArg = args[0];
  if (typeof firstArg === 'string' && resizeObserverLoopErr.test(firstArg)) {
    return;
  }
  originalError.call(console, ...args);
};

// Suppress console.warn
console.warn = (...args) => {
  const firstArg = args[0];
  if (typeof firstArg === 'string' && resizeObserverLoopErr.test(firstArg)) {
    return;
  }
  originalWarn.call(console, ...args);
};

// Suppress window.onerror
window.addEventListener('error', (event) => {
  if (resizeObserverLoopErr.test(event.message)) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
